import React, { FC } from "react";
import Modal from "../../atoms/Modal";

interface ReportActionModalProps {
  isOpen: boolean;
  onClose: () => void;
  action: "approve" | "refuse" | "approvePerManager" | "sendToApproval" | "markAsPaid" | "approveAll";
  onConfirm: () => void;
  setIsOpen: (value: boolean) => void | undefined;
  onRefuseReasonChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onApproveReasonChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  approveReason?: string;
  refuseReason?: string;
}

const modalText = {
  approve: "Você tem certeza que deseja aprovar essa solicitação?",
  refuse: "Você tem certeza que deseja rejeitar essa solicitação?",
  approvePerManager: "Você tem certeza que deseja aprovar essa solicitação pelo Gestor?",
  sendToApproval: "Você tem certeza que deseja enviar essa solicitação para aprovação?",
  approveAll: "Você tem certeza que deseja aprovar todas as solicitações da lista?",
  markAsPaid: "Você tem certeza que deseja marcar este adiantamento como pago?",
};

const ReportActionModal: FC<ReportActionModalProps> = ({
  isOpen,
  setIsOpen,
  onClose,
  action,
  onConfirm,
  onRefuseReasonChange,
  onApproveReasonChange,
  approveReason,
  refuseReason,
}) => {
  const isApproveReasonRequired = action === "approvePerManager";
  const isRefuseReasonRequired = action === "refuse";

  const isConfirmDisabled =
    (isApproveReasonRequired && (!approveReason || approveReason.trim() === "")) ||
    (isRefuseReasonRequired && (!refuseReason || refuseReason.trim() === ""));

  return (
    <Modal
      title="Atenção"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      body={
        <div className="mt-2">
          <p className="text-sm text-gray-500">{modalText[action]}</p>
        </div>
      }
      bottom={
        <div className="flex flex-col my-2">
          {action === "refuse" && (
            <textarea
              className="w-full bg-gray-50 border border-gray-300 text-gray-500 text-sm rounded-md block p-1 dark:bg-white dark:border-gray-400 dark:placeholder-gray-400 dark:text-gray-600 outline-none"
              name="refuseReason"
              rows={5}
              value={refuseReason}
              placeholder="Escreva o motivo da recusa (obrigatório) ..."
              onChange={onRefuseReasonChange}
            />
          )}

          {action === "approvePerManager" && (
            <textarea
              className="w-full bg-gray-50 border border-gray-300 text-gray-500 text-sm rounded-md block p-1 dark:bg-white dark:border-gray-400 dark:placeholder-gray-400 dark:text-gray-600 outline-none"
              name="approveReason"
              rows={5}
              value={approveReason}
              placeholder="Escreva o motivo da aprovação (obrigatório) ..."
              onChange={onApproveReasonChange}
            />
          )}

          <div className="flex flex-row justify-around mt-4">
            <button
              type="button"
              className={`inline-flex justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 ${
                isConfirmDisabled ? "bg-gray-300 cursor-not-allowed" : "bg-green-400 hover:bg-vcolor"
              }`}
              onClick={onConfirm}
              disabled={isConfirmDisabled}
            >
              Sim
            </button>
            <button
              type="button"
              className="inline-flex justify-center rounded-md border border-transparent bg-red-400 px-4 py-2 text-sm font-medium text-white hover:bg-vcolor focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
              onClick={() => {
                onClose();
                setIsOpen(false);
              }}
            >
              Não
            </button>
          </div>
        </div>
      }
    />
  );
};

export default ReportActionModal;
